import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

import { createReturn } from '../../api/apiReturns';
import parseError from '../../utils/parseError';

export const useCreateReturn = () => {
    const { t } = useTranslation();
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: createReturn,
        onSuccess: (response) => {
            const number = response?.data?.data?.return_number;
            toast.success(
                number
                    ? t('returns.createdWithNumber', { defaultValue: 'Return {{n}} submitted', n: number })
                    : t('returns.created', 'Return submitted')
            );
            queryClient.invalidateQueries({ queryKey: ['my-returns'] });
        },
        onError: (err) => {
            // 422 surfaces inline on the form; other errors as toast.
            if (err?.response?.status !== 422) {
                toast.error(parseError(err) || t('returns.createError', 'Could not submit return'));
            }
        },
    });
};

export default useCreateReturn;
